import { ShiftsReferenceContractFragment } from 'generated/resources/graphql'

export interface Props {
  id: number | null | undefined
  jobTitle: string | null | undefined
  jobCatalogName: string | undefined
  jobCatalogRoleName: string | undefined
  workingHours: number | null | undefined
  workingHoursFrequency: string | null | undefined
  workingWeekDays: string | null | undefined
  fragment: ShiftsReferenceContractFragment
}

class ReferenceContract {
  id: number
  jobTitle: string
  jobCatalogName: string
  jobCatalogRoleName: string
  workingHours: number
  workingHoursFrequency: string
  workingWeekDays: string
  fragment: ShiftsReferenceContractFragment

  constructor(props: Props) {
    this.id = props.id || 0
    this.jobTitle = props.jobTitle || ''
    this.jobCatalogName = props.jobCatalogName || ''
    this.jobCatalogRoleName = props.jobCatalogRoleName || ''
    this.workingHours = props.workingHours || 0
    this.workingHoursFrequency = props.workingHoursFrequency || ''
    this.workingWeekDays = props.workingWeekDays || ''

    this.fragment = props.fragment
  }

  static buildFromGraphQL(fragment: ShiftsReferenceContractFragment): ReferenceContract {
    return new ReferenceContract({
      id: fragment.id,
      jobTitle: fragment.jobTitle,
      jobCatalogName: fragment.jobCatalogLevel?.name,
      jobCatalogRoleName: fragment.jobCatalogLevel?.roleName,
      workingHours: fragment.workingHours,
      workingHoursFrequency: fragment.workingHoursFrequency,
      workingWeekDays: fragment.workingWeekDays,
      fragment,
    })
  }
}

export default ReferenceContract
